export const EmailOrderItem = (itemImg, itemName, sellerName, sku, quantity, price) =>
   `<table cellpadding="0" cellspacing="0" border="0" width="88%" style="width: 88% !important; min-width: 88%; max-width: 88%; border-width: 1px; border-style: solid; border-color: #e2e2e2; border-top: none; border-left: none; border-right: none;">
<tr>
   <td align="left" valign="middle" width="17%" style="width: 17%; max-width: 17%; min-width: 20px">
      <div style="height: 10px; line-height: 10px; font-size: 10px;">&nbsp;</div>
      <a href="#" target="_blank" style="display: block; max-width: 99px;">
         <img src="${itemImg}" alt="img" width="99" border="0" style="display: block; width: 99px; max-width: 100%; border-radius: 20px;" />
      </a>
      <div style="height: 10px; line-height: 10px; font-size: 10px;">&nbsp;</div>
   </td>
   <td width="7" style="width: 7px; max-width: 7px; min-width: 7px;">&nbsp;</td>
   <td align="left" valign="top" width="57%" style="width: 57%; max-width: 57%; min-width: 90px">
      <div style="height: 22px; line-height: 22px; font-size: 20px;">&nbsp;</div>
      <font face="'Source Sans Pro', sans-serif" color="#000000" style="font-size: 17px; line-height: 21px; font-weight: 600;">
         <span style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #000000; font-size: 17px; line-height: 21px; font-weight: 600;">${itemName}</span>
      </font>
      <div style="height: 2px; line-height: 2px; font-size: 1px;">&nbsp;</div>
      <font face="'Source Sans Pro', sans-serif" color="#000000" style="font-size: 17px; line-height: 21px;">
         <span style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #000000; font-size: 17px; line-height: 21px;">${sellerName}<br>SKU: ${sku}</span>
      </font>
      <div style="height: 10px; line-height: 10px; font-size: 10px;">&nbsp;</div>
   </td>
   <td width="7" style="width: 7px; max-width: 7px; min-width: 7px;">&nbsp;</td>
   <td align="left" valign="top" width="10%" style="width: 10%; max-width: 10%; min-width: 40px">
      <div style="height: 22px; line-height: 22px; font-size: 20px;">&nbsp;</div>
      <font face="'Source Sans Pro', sans-serif" color="#000000" style="font-size: 17px; line-height: 21px;">
         <span style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #000000; font-size: 17px; line-height: 21px;">${quantity}</span>
      </font>
      <div style="height: 10px; line-height: 10px; font-size: 10px;">&nbsp;</div>
   </td>
   <td width="7" style="width: 7px; max-width: 7px; min-width: 7px;">&nbsp;</td>
   <td align="right" valign="top" width="12%" style="width: 12%; max-width: 12%; min-width: 70px">
      <div style="height: 22px; line-height: 22px; font-size: 20px;">&nbsp;</div>
      <font face="'Source Sans Pro', sans-serif" color="#000000" style="font-size: 17px; line-height: 21px;">
         <span style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #000000; font-size: 17px; line-height: 21px;">${price}</span>
      </font>
      <div style="height: 10px; line-height: 10px; font-size: 10px;">&nbsp;</div>
   </td>
</tr>
</table>
`